import {
  boolFilter,
  selectedKeyFilter,
  stringFilter,
} from '@/components/Internal/DataTable'

export const elementTypesListFilters = {
  search: stringFilter(),

  /** Narrows the list to types nothing points at — what a cleanup starts from. */
  unusedOnly: boolFilter(),

  /** The open row: a band's key or a type's, both addresses the pane shows. */
  selected: selectedKeyFilter(),
}
